import type ReactQuill from 'react-quill-new';

type QuillEditor = ReturnType<ReactQuill['getEditor']>;

export function findEditorImageBySrc(editor: QuillEditor, src: string): HTMLImageElement | null {
  const images = Array.from(editor.root.querySelectorAll('img'));
  return images.find((image) => image.getAttribute('src') === src) ?? null;
}
